<div class="min-vh-100 py-4 d-flex align-items-center justify-content-center">
    @if (!(loggedIn$ | async)) {
        <div class="d-flex align-items-center justify-content-center flex-column">
            <mat-card class="mat-mdc-elevation-specific mat-elevation-z0 rounded-lg">
                <mat-card-content class="px-5">
                    <h1 class="page-title">
                        {{ 'auth.recover.page_title' | translate }}
                    </h1>

                    <app-form-error class="d-block mb-3" [error]="error$ | async" />

                    <form [formGroup]="form" class="recover-confirm-form">
                        @if (recoverData$ | async) {
                            <div class="code-field-container">
                                <mat-form-field class="field">
                                    <mat-label>{{ 'app.form.labels.code' | translate }}</mat-label>
                                    <input matInput
                                           type="text"
                                           placeholder="0000"
                                           [imask]="{ mask: '0000' }"
                                           minlength="4"
                                           maxlength="4"
                                           [formControlName]="'code'"
                                           required
                                           autocomplete="off" />
                                </mat-form-field>

                                @if (form.touched && codeControl.hasError('required')) {
                                    <mat-error class="error">
                                        {{ 'auth.errors.code_required' | translate }}
                                    </mat-error>
                                }

                                <mat-panel-description class="d-block">
                                    @let lockUp = lockUp$ | async;
                                    @if (lockUp) {
                                        <small class="resend-message" role="timer">
                                            {{ 'auth.confirm.resend_timeout'| translate: { time: lockUp | lockupTime } }}
                                        </small>
                                    }
                                </mat-panel-description>
                            </div>
                        }


                        <div class="d-flex justify-content-between mt-6">
                            <button mat-raised-button
                                    class="mat-elevation-z0 mat-mdc-elevation-specific"
                                    type="submit"
                                    [color]="'primary'"
                                    [disabled]="form.invalid || (pending$ | async)"
                                    (click)="onSubmit()">{{ 'app.actions.confirm' | translate }}
                            </button>
                            <button mat-raised-button
                                    class="mat-elevation-z0 mat-mdc-elevation-specific"
                                    [disabled]="(pending$ | async) || (lockUp$ | async) > 0"
                                    (click)="onResendClick()">{{ 'app.actions.resend' | translate }}
                            </button>
                        </div>
                    </form>
                </mat-card-content>
            </mat-card>
        </div>
    }
</div>
